/**
 * Shared with the server's `decks.ts`.
 *
 * Only the alias lives here: the client needs to name "the deck at /" without
 * first asking which deck that is, and hardcoding the character in two places
 * is how the two drift.
 */
export const DEFAULT_DECK_ALIAS = '-';
